// eslint-disable-next-line no-undef
const object = vnObject

const autocompleteHit = (item) => {
  const { title } = item
  const url = `${object.faqPage}/${object.faqsQueryStrings.query}/${title}`

  return `
  <li>
    <a href="${url}" class="feed-autocomplete" target="_blank">
      <span class="feed-autocomplete__title">${item._highlightResult.title.value}</span>
    </a>
  </li>
  `
}

export default autocompleteHit
